import { render, staticRenderFns } from "./OpportunityCard.vue?vue&type=template&id=30ae77ae&scoped=true&"
import script from "./OpportunityCard.vue?vue&type=script&lang=js&"
export * from "./OpportunityCard.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityCard.vue?vue&type=style&index=0&id=30ae77ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ae77ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VIcon,VProgressLinear,VTooltip})
